// import React, { useEffect, useRef } from "react";
// import { getCoordinates } from "../helper/functions";

// const LocationPicker = ({ onLocationSelect }) => {
//   const mapRef = useRef(null);
//   const mapInstance = useRef(null);
//   const markerInstance = useRef(null);

//   useEffect(() => {
//     const map = new window.google.maps.Map(mapRef.current, {
//       center: { lat: 25.2048, lng: 55.2708 }, // Default Dubai
//       zoom: 12,
//     });

//     let marker;

//     // On map click
//     map.addListener("click", (e) => {
//       const lat = e.latLng.lat();
//       const lng = e.latLng.lng();

//       if (marker) marker.setMap(null);
//       marker = new window.google.maps.Marker({
//         position: { lat, lng },
//         map,
//       });

//       // Reverse geocode (lat,lng -> address)
//       const geocoder = new window.google.maps.Geocoder();
//       geocoder.geocode({ location: { lat, lng } }, (results, status) => {
//         if (status === "OK" && results[0]) {
//           const addressComponents = results[0].address_components;
//           let city = "";
//           let state = "";
//           let country = "";

//           addressComponents.forEach((component) => {
//             if (component.types.includes("locality")) {
//               city = component.long_name;
//             }
//             if (component.types.includes("administrative_area_level_1")) {
//               state = component.long_name;
//             }
//             if (component.types.includes("country")) {
//               country = component.long_name;
//             }
//           });

//           onLocationSelect({
//             lat,
//             lng,
//             address: results[0].formatted_address,
//             city,
//             state,
//             country,
//           });
//         }
//       });
//     });
//   }, []);

//   // ⭐ Function to handle map click OR current GPS location
//   const handleLocation = (lat, lng) => {
//     console.log("map instance-->", mapInstance);
//     if (!mapInstance.current) return;

//     // Remove old marker
//     if (markerInstance.current) markerInstance.current.setMap(null);

//     // Add new marker
//     markerInstance.current = new window.google.maps.Marker({
//       position: { lat, lng },
//       map: mapInstance.current,
//     });

//     // Move map center
//     mapInstance.current.setCenter({ lat, lng });

//     const geocoder = new window.google.maps.Geocoder();

//     geocoder.geocode({ location: { lat, lng } }, (results, status) => {
//       if (status === "OK" && results[0]) {
//         const addressComponents = results[0].address_components;

//         let city = "";
//         let state = "";
//         let country = "";

//         addressComponents.forEach((component) => {
//           if (component.types.includes("locality")) city = component.long_name;
//           if (component.types.includes("administrative_area_level_1"))
//             state = component.long_name;
//           if (component.types.includes("country"))
//             country = component.long_name;
//         });

//         // Send to parent
//         onLocationSelect({
//           lat,
//           lng,
//           address: results[0].formatted_address,
//           city,
//           state,
//           country,
//         });

//         // Move map center
//         // SAFE FIX — check before setCenter
//         if (mapInstance.current) {
//           mapInstance.current.setCenter({ lat, lng });
//         }
//       }
//     });
//   };

//   // ⭐ Get user's live current location
//   const chooseCurrentLocation = async () => {
//     if (!navigator.geolocation) {
//       alert("Geolocation not supported by your browser.");
//       return;
//     }

//     const result = await getCoordinates();
//     if (result) {
//       handleLocation(result.latitude, result.longitude);
//     }
//   };

//   return (
//     <div style={{ width: "100%", height: "100%" }}>
//       {/* Current Location Button */}
//       <button
//         onClick={chooseCurrentLocation}
//         style={{
//           position: "absolute",
//           zIndex: 10,
//           top: "10px",
//           right: "10px",
//           padding: "8px 14px",
//           background: "#ff8c00",
//           color: "white",
//           border: "none",
//           borderRadius: "8px",
//           cursor: "pointer",
//           fontWeight: "600",
//         }}
//       >
//         📍 Current Location
//       </button>

//       {/* Map */}
//       <div ref={mapRef} style={{ width: "100%", height: "83vh" }} />
//     </div>
//   );
// };

// export default LocationPicker;

import React, { useEffect, useRef } from "react";
import { getCoordinates } from "../helper/functions";

const LocationPicker = ({ onLocationSelect }) => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerInstance = useRef(null);

  useEffect(() => {
    // Create map ONCE
    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: { lat: 25.2048, lng: 55.2708 },
      zoom: 12,
    });

    // Add click listener ONCE
    mapInstance.current.addListener("click", (e) => {
      handleLocation(e.latLng.lat(), e.latLng.lng());
    });
  }, []);

  const handleLocation = (lat, lng) => {
    if (!mapInstance.current) return;

    // Remove old marker
    if (markerInstance.current) markerInstance.current.setMap(null);

    // Add new marker
    markerInstance.current = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapInstance.current,
    });

    // Move map center
    mapInstance.current.setCenter({ lat, lng });

    // Reverse geocode
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const comps = results[0].address_components;
        let city = "";
        let state = "";
        let country = "";

        comps.forEach((c) => {
          if (c.types.includes("locality")) city = c.long_name;
          if (c.types.includes("administrative_area_level_1"))
            state = c.long_name;
          if (c.types.includes("country")) country = c.long_name;
        });

        onLocationSelect({
          lat,
          lng,
          address: results[0].formatted_address,
          city,
          state,
          country,
        });
      }
    });
  };

  const chooseCurrentLocation = async () => {
    const result = await getCoordinates();
    if (result) {
      // DO NOT CREATE NEW MAP HERE
      // Just move center + set marker
      handleLocation(result.latitude, result.longitude);
    }
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <button
        onClick={chooseCurrentLocation}
        className="address-current-location-button"
      >
        📍 Current Location
      </button>

      <div ref={mapRef} style={{ width: "100%", height: "83vh" }} />
    </div>
  );
};

export default LocationPicker;
